import { skills } from "./skills_data";

export default function Skills() {
  return (
    <div
      id="skills"
      className="min-h-screen bg-whitish py-16 dark:bg-greenish px-3 flex flex-col justify-center items-center"
    >
      <p className="mb-10 text-center overline text-greenish text-4xl font-bold dark:text-beige">
        My Skills
      </p>
      <div className="grid md:grid-cols-4 sm:grid-cols-3 grid-cols-2 content-center justify-items-center gap-y-9 gap-x-5">
        {skills.map((skill: any) => {
          return (
            <div
              key={skill.id}
              className="sm:w-44 w-36 mx-3 rounded-lg shadow-lg dark:shadow-night  hover:scale-110 duration-500"
            >
              <img
                src={skill.image}
                alt={skill.skill}
                className="my-4 sm:max-w-sm w-auto mx-auto max-h-20"
              />
              <p className="m-6 uppercase dark:text-whitish text-night  text-center">
                {skill.skill}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}